import * as navigation from './components/ost.navigation';
import * as loginModal from './components/ost.login-modal-dialog';
import * as search from './components/ost.search';
import * as bookmark from './components/ost.bookmark';
import * as calendar from './components/ost.calendar';
import * as alert from './components/ost.alertblock';
import * as orglist from './components/ost.orglist';
import * as workroom from './components/ost.workroom';
import * as quiz from './components/ost.quiz';


class Index {
    
    constructor() {
        this.navigation = new navigation.Navigation();
        this.loginModal = new loginModal.LoginModalDialog("#modal-dialog-container");
        this.search = new search.Search(".js-auto-update-form", ".searchResult");
        this.bookmark = new bookmark.Bookmark();
        this.calendar = new calendar.Calendar();
        this.alert = new alert.AlertBlock(".js-alertblock-button");
        this.orglist = new orglist.OrganizationList();
        this.workroom = new workroom.Workroom();
        this.quiz = new quiz.Quiz();
    }

    init() {
        this.navigation.init();
        this.loginModal.init();
        this.search.init();
        this.bookmark.init();
        this.calendar.init();
        this.alert.init();        
        this.orglist.init();
        this.workroom.init();
        this.quiz.init();
    }
}

$(document).ready(() => {
    var index = new Index();
    index.init();

    $(".nav-link-arrow").click(function (e) {
        e.preventDefault();
        const getParent = $(this).parent();

        getParent.toggleClass("expand");
    });

    // Filter toggle on search page. Not used after redesign 2024
    //$(".filter-toggle").click(function (e) {
    //    e.preventDefault();
    //    const searchFilter = $(".search-filter");

    //    searchFilter.toggleClass("active");
    //});

    $(".arrow").click(function (e) {
        e.preventDefault();
        const getParent = $(this).parent();

        getParent.toggleClass("expand");
    });
});

$(document).mouseup(function (e) {
    const container = $(".nav-shortcuts");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('active');
    }
});



// WEBPACK FOOTER //
// ./frontend/js/index.js